<template>
  <div>
    <!-- 점수가 있으면 점수 출력 및 결과 보기 -->
    <span v-if="answer" >
      <mdb-btn v-if="answer.score" class="p-1" @click="onViewResult" :color="answer.score < failScore ? 'danger' : ''">{{answer.score}}</mdb-btn>
      <span v-else><small>미채점</small></span>
    </span>
    <!-- 평가일이면 응시 / 아니면 평가일 출력-->
    <span v-else-if="isTestDate" >
      <mdb-btn class="p-1" @click="onTest" color="primary">응시</mdb-btn>
    </span>
    <mdb-btn v-if="test && test['task'+seq].testQuestion"  class="p-1" @click="onViewTest">문제</mdb-btn>

    <!-- 문제보기 모달 -->
    <mdb-modal size="lg" :show="modal" @close="modal = false" scrollable class="text-left">
      <mdb-modal-header>
        <mdb-modal-title class="bolder"><mdb-icon icon="chalkboard-teacher" /> {{task.title}}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="text-right clcok"><mdb-icon icon="clock"/> 평가일: {{$strDate(task.testDate)}}</div>
        <div class="title my-3"><mdb-icon icon="caret-square-right" /> 실습 예제</div>
        <div class="ml-3" v-html="$linebreak(task.testQuestion)"/>
        <div class="title my-3"><mdb-icon icon="caret-square-right" /> 평가 기준</div>
        <div class="ml-3" v-html="$linebreak(task.testGuide)"/>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="secondary" icon="times" @click.native="modal = false">닫기</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>
<script>
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';
import { mapGetters } from 'vuex';
export default {
  name: 'PerformTestStatus',
  components: { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter },
  props: ['test', 'answer', 'seq'],
  data: () => ({
    TAG: 'PerformTestStatus :',
    task: {},
    modal: false
  }),
  computed: {
    ...mapGetters('auth', ['failScore']),
    score () {
      return this.answer.score
    },
    isTestDate () {
      if (!this.test) return false;
      let testDate;
      if (this.seq === 1) {
        testDate = this.test.task1 && this.$isTestDate(this.test.task1.testDate)
      } else {
        testDate = this.test.task2 && this.$isTestDate(this.test.task2.testDate)
      }
      return testDate
    }
  },
  methods: {
    onViewTest () {
      this.modal = true;
      this.task = this.test['task' + this.seq]
      this.task.title = `${this.test.name} 수행평가 과제`
    },
    onViewResult () {
      const test = this.test._id
      const answer = this.answer._id
      const query = { test, answer }
      this.$router.push({ name: 'StudentPerformTestView', query })
    },
    onTest () {
      const query = {
        name: this.test.name,
        code: this.test.code,
        seq: this.seq
      }
      this.$router.push({ name: 'StudentPerformTestExam', query })
    }
  }
}
</script>
